import { CommonModule } from '@angular/common';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import * as i0 from "@angular/core";
export class IconSearchAutocompleteModule {
}
IconSearchAutocompleteModule.ɵfac = function IconSearchAutocompleteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconSearchAutocompleteModule)(); };
IconSearchAutocompleteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IconSearchAutocompleteModule });
IconSearchAutocompleteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule, CommonModule] });
